import { render, staticRenderFns } from "./Modal-item.vue?vue&type=template&id=a23900be&scoped=true&lang=pug"
import script from "./Modal-item.vue?vue&type=script&lang=js"
export * from "./Modal-item.vue?vue&type=script&lang=js"
import style0 from "./Modal-item.vue?vue&type=style&index=0&id=a23900be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23900be",
  null
  
)

export default component.exports